import { render, staticRenderFns } from "./SubheadingSection.vue?vue&type=template&id=1b1686c6"
import script from "./SubheadingSection.vue?vue&type=script&lang=js"
export * from "./SubheadingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports